import { Button, Col, Modal, Row, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { FaDownload } from "react-icons/fa6";

const { Text } = Typography;

const ExportContent = ({ visible, onCancel, onExport, title }) => {
  const { t } = useTranslation();
  return (
    <Modal
      open={visible}
      onCancel={onCancel}
      destroyOnClose={true}
      okButtonProps={{ className: "hidden" }}
      cancelText={t("button.close")}
      title={title || t("button.export")}
    >
      <div className="my-5">
        <Row justify="space-around" className="border-b border-b-gray-200 py-3">
          <Col>
            <Button
              type="text"
              icon={<FaDownload className="text-primary" />}
              onClick={() => {
                onExport("xls");
              }}
            >
              <Text className="text-link-primary hover:cursor-pointer">
                {t("attendance.download", { type: "xlsx" })}
              </Text>
            </Button>
          </Col>
          <Col>
            <Button
              type="text"
              icon={<FaDownload className="text-primary" />}
              onClick={() => {
                onExport("csv");
              }}
            >
              <Text className="text-link-primary hover:cursor-pointer">
                {t("attendance.download", { type: "csv" })}
              </Text>
            </Button>
          </Col>
        </Row>
      </div>
    </Modal>
  );
};

export default ExportContent;
